import React, { useState } from 'react';
import { UserIcon, KeyIcon, MailIcon, PhoneIcon, ShieldIcon, BellIcon, GlobeIcon, HelpCircleIcon, SaveIcon, UsersIcon, LogOutIcon, CheckIcon } from 'lucide-react';
const SettingsScreen = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [saveSuccess, setSaveSuccess] = useState(false);
  // Sample admin data
  const adminData = {
    name: 'Admin User',
    email: 'admin@burhaniguards.org',
    phone: '+91 98765 12345',
    role: 'Super Admin',
    lastLogin: '2023-08-15 10:30 AM',
    profileImage: 'https://randomuser.me/api/portraits/men/1.jpg'
  };
  // Sample roles data
  const roles = [{
    id: 1,
    name: 'Super Admin',
    description: 'Full access to all features',
    count: 2
  }, {
    id: 2,
    name: 'Admin',
    description: 'Can manage members, duties and lawajam',
    count: 5
  }, {
    id: 3,
    name: 'Duty Manager',
    description: 'Can manage duties only',
    count: 3
  }, {
    id: 4,
    name: 'Lawajam Manager',
    description: 'Can manage lawajam only',
    count: 4
  }, {
    id: 5,
    name: 'Viewer',
    description: 'Can only view data',
    count: 10
  }];
  // Function to handle form submission
  const handleSubmit = e => {
    e.preventDefault();
    // Show success message
    setSaveSuccess(true);
    // Hide success message after 3 seconds
    setTimeout(() => {
      setSaveSuccess(false);
    }, 3000);
  };
  return <div className="space-y-6" data-id="element-802">
      <div className="flex justify-between items-center" data-id="element-803">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-804">Settings</h1>
      </div>
      <div className="bg-white rounded-lg shadow" data-id="element-805">
        <div className="md:flex" data-id="element-806">
          {/* Sidebar */}
          <div className="md:w-64 border-r" data-id="element-807">
            <nav className="p-4 space-y-1" data-id="element-808">
              <button onClick={() => setActiveTab('profile')} className={`flex items-center w-full px-3 py-2 rounded-md ${activeTab === 'profile' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-809">
                <UserIcon size={18} className="mr-3" data-id="element-810" />
                <span data-id="element-811">Profile</span>
              </button>
              <button onClick={() => setActiveTab('security')} className={`flex items-center w-full px-3 py-2 rounded-md ${activeTab === 'security' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-812">
                <KeyIcon size={18} className="mr-3" data-id="element-813" />
                <span data-id="element-814">Security</span>
              </button>
              <button onClick={() => setActiveTab('roles')} className={`flex items-center w-full px-3 py-2 rounded-md ${activeTab === 'roles' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-815">
                <ShieldIcon size={18} className="mr-3" data-id="element-816" />
                <span data-id="element-817">Roles & Permissions</span>
              </button>
              <button onClick={() => setActiveTab('notifications')} className={`flex items-center w-full px-3 py-2 rounded-md ${activeTab === 'notifications' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-818">
                <BellIcon size={18} className="mr-3" data-id="element-819" />
                <span data-id="element-820">Notifications</span>
              </button>
              <button onClick={() => setActiveTab('system')} className={`flex items-center w-full px-3 py-2 rounded-md ${activeTab === 'system' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-821">
                <GlobeIcon size={18} className="mr-3" data-id="element-822" />
                <span data-id="element-823">System Settings</span>
              </button>
              <button onClick={() => setActiveTab('help')} className={`flex items-center w-full px-3 py-2 rounded-md ${activeTab === 'help' ? 'bg-blue-800 text-white' : 'hover:bg-gray-100'}`} data-id="element-824">
                <HelpCircleIcon size={18} className="mr-3" data-id="element-825" />
                <span data-id="element-826">Help & Support</span>
              </button>
            </nav>
          </div>
          {/* Content area */}
          <div className="flex-1 p-6" data-id="element-827">
            {/* Profile Tab */}
            {activeTab === 'profile' && <div data-id="element-828">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-829">
                  Profile Settings
                </h2>
                <div className="flex items-center mb-6" data-id="element-830">
                  <div className="mr-4" data-id="element-831">
                    <img src={adminData.profileImage} alt="Admin" className="w-20 h-20 rounded-full object-cover" data-id="element-832" />
                  </div>
                  <div data-id="element-833">
                    <button className="bg-blue-800 text-white px-3 py-1 rounded-md text-sm" data-id="element-834">
                      Change Photo
                    </button>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-835">
                      JPG, PNG or GIF. Maximum size 2MB.
                    </p>
                  </div>
                </div>
                <form onSubmit={handleSubmit} data-id="element-836">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-837">
                    <div data-id="element-838">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-839">
                        Full Name
                      </label>
                      <input type="text" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={adminData.name} data-id="element-840" />
                    </div>
                    <div data-id="element-841">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-842">
                        Role
                      </label>
                      <input type="text" className="px-3 py-2 border rounded-md w-full bg-gray-50" value={adminData.role} disabled data-id="element-843" />
                    </div>
                    <div data-id="element-844">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-845">
                        Email
                      </label>
                      <div className="relative" data-id="element-846">
                        <MailIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-847" />
                        <input type="email" className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={adminData.email} data-id="element-848" />
                      </div>
                    </div>
                    <div data-id="element-849">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-850">
                        Phone
                      </label>
                      <div className="relative" data-id="element-851">
                        <PhoneIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-852" />
                        <input type="tel" className="pl-10 pr-4 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue={adminData.phone} data-id="element-853" />
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-854">
                    <div className="flex justify-between items-center" data-id="element-855">
                      <button type="submit" className="bg-blue-800 text-white px-4 py-2 rounded-md flex items-center" data-id="element-856">
                        <SaveIcon size={18} className="mr-1" data-id="element-857" />
                        Save Changes
                      </button>
                      {saveSuccess && <div className="flex items-center text-green-600" data-id="element-858">
                          <CheckIcon size={18} className="mr-1" data-id="element-859" />
                          <span data-id="element-860">Changes saved successfully!</span>
                        </div>}
                    </div>
                  </div>
                </form>
              </div>}
            {/* Security Tab */}
            {activeTab === 'security' && <div data-id="element-861">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-862">
                  Security Settings
                </h2>
                <div className="space-y-6" data-id="element-863">
                  <div data-id="element-864">
                    <h3 className="text-md font-medium mb-4" data-id="element-865">
                      Change Password
                    </h3>
                    <div className="space-y-4" data-id="element-866">
                      <div data-id="element-867">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-868">
                          Current Password
                        </label>
                        <input type="password" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter current password" data-id="element-869" />
                      </div>
                      <div data-id="element-870">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-871">
                          New Password
                        </label>
                        <input type="password" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter new password" data-id="element-872" />
                      </div>
                      <div data-id="element-873">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-874">
                          Confirm New Password
                        </label>
                        <input type="password" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Confirm new password" data-id="element-875" />
                      </div>
                      <button className="bg-blue-800 text-white px-4 py-2 rounded-md" data-id="element-876">
                        Update Password
                      </button>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-877">
                    <h3 className="text-md font-medium mb-4" data-id="element-878">Login History</h3>
                    <div className="bg-gray-50 rounded-md p-4 space-y-3" data-id="element-879">
                      <div className="flex justify-between items-center" data-id="element-880">
                        <div data-id="element-881">
                          <div className="font-medium" data-id="element-882">Today, 10:30 AM</div>
                          <div className="text-sm text-gray-500" data-id="element-883">
                            192.168.1.1 - Chrome on Windows
                          </div>
                        </div>
                        <div className="text-green-600 text-sm" data-id="element-884">
                          Current Session
                        </div>
                      </div>
                      <div className="flex justify-between items-center" data-id="element-885">
                        <div data-id="element-886">
                          <div className="font-medium" data-id="element-887">Yesterday, 08:45 PM</div>
                          <div className="text-sm text-gray-500" data-id="element-888">
                            192.168.1.1 - Chrome on Windows
                          </div>
                        </div>
                        <div className="text-gray-500 text-sm" data-id="element-889">Logged out</div>
                      </div>
                      <div className="flex justify-between items-center" data-id="element-890">
                        <div data-id="element-891">
                          <div className="font-medium" data-id="element-892">
                            Aug 13, 2023, 02:15 PM
                          </div>
                          <div className="text-sm text-gray-500" data-id="element-893">
                            192.168.1.1 - Chrome on Windows
                          </div>
                        </div>
                        <div className="text-gray-500 text-sm" data-id="element-894">Logged out</div>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-895">
                    <h3 className="text-md font-medium mb-4" data-id="element-896">
                      Two-Factor Authentication
                    </h3>
                    <div className="flex items-center justify-between" data-id="element-897">
                      <div data-id="element-898">
                        <div className="font-medium" data-id="element-899">
                          Protect your account with 2FA
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-900">
                          Add an extra layer of security to your account
                        </div>
                      </div>
                      <button className="bg-green-700 text-white px-4 py-2 rounded-md" data-id="element-901">
                        Enable 2FA
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Roles Tab */}
            {activeTab === 'roles' && <div data-id="element-902">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-903">
                  Roles & Permissions
                </h2>
                <div className="flex justify-between items-center mb-4" data-id="element-904">
                  <div data-id="element-905">
                    <p className="text-sm text-gray-500" data-id="element-906">
                      Manage user roles and their permissions in the system.
                    </p>
                  </div>
                  <button className="bg-blue-800 text-white px-3 py-1 rounded-md text-sm flex items-center" data-id="element-907">
                    <UsersIcon size={16} className="mr-1" data-id="element-908" />
                    Add New Role
                  </button>
                </div>
                <div className="overflow-x-auto" data-id="element-909">
                  <table className="min-w-full divide-y divide-gray-200" data-id="element-910">
                    <thead className="bg-gray-50" data-id="element-911">
                      <tr data-id="element-912">
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-913">
                          Role Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-914">
                          Description
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-915">
                          Users
                        </th>
                        <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-916">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200" data-id="element-917">
                      {roles.map(role => <tr key={role.id} className="hover:bg-gray-50" data-id="element-918">
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-919">
                            <div className="text-sm font-medium text-gray-900" data-id="element-920">
                              {role.name}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-921">
                            <div className="text-sm text-gray-500" data-id="element-922">
                              {role.description}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap" data-id="element-923">
                            <div className="text-sm text-gray-900" data-id="element-924">
                              {role.count} users
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-925">
                            <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-926">
                              Edit
                            </button>
                            <button className="text-red-600 hover:text-red-900" data-id="element-927">
                              Delete
                            </button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
                <div className="mt-8 border-t pt-6" data-id="element-928">
                  <h3 className="text-md font-medium mb-4" data-id="element-929">
                    Permission Groups
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-930">
                    <div className="border rounded-md p-4" data-id="element-931">
                      <h4 className="font-medium mb-2" data-id="element-932">Member Management</h4>
                      <div className="space-y-2 text-sm" data-id="element-933">
                        <div className="flex items-center" data-id="element-934">
                          <input type="checkbox" id="view-members" className="mr-2" checked data-id="element-935" />
                          <label htmlFor="view-members" data-id="element-936">View Members</label>
                        </div>
                        <div className="flex items-center" data-id="element-937">
                          <input type="checkbox" id="add-members" className="mr-2" checked data-id="element-938" />
                          <label htmlFor="add-members" data-id="element-939">Add Members</label>
                        </div>
                        <div className="flex items-center" data-id="element-940">
                          <input type="checkbox" id="edit-members" className="mr-2" checked data-id="element-941" />
                          <label htmlFor="edit-members" data-id="element-942">Edit Members</label>
                        </div>
                        <div className="flex items-center" data-id="element-943">
                          <input type="checkbox" id="delete-members" className="mr-2" checked data-id="element-944" />
                          <label htmlFor="delete-members" data-id="element-945">
                            Deactivate Members
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="border rounded-md p-4" data-id="element-946">
                      <h4 className="font-medium mb-2" data-id="element-947">Duty Management</h4>
                      <div className="space-y-2 text-sm" data-id="element-948">
                        <div className="flex items-center" data-id="element-949">
                          <input type="checkbox" id="view-duties" className="mr-2" checked data-id="element-950" />
                          <label htmlFor="view-duties" data-id="element-951">View Duties</label>
                        </div>
                        <div className="flex items-center" data-id="element-952">
                          <input type="checkbox" id="add-duties" className="mr-2" checked data-id="element-953" />
                          <label htmlFor="add-duties" data-id="element-954">Create Duties</label>
                        </div>
                        <div className="flex items-center" data-id="element-955">
                          <input type="checkbox" id="assign-duties" className="mr-2" checked data-id="element-956" />
                          <label htmlFor="assign-duties" data-id="element-957">
                            Assign Members to Duties
                          </label>
                        </div>
                        <div className="flex items-center" data-id="element-958">
                          <input type="checkbox" id="delete-duties" className="mr-2" checked data-id="element-959" />
                          <label htmlFor="delete-duties" data-id="element-960">Delete Duties</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Notifications Tab */}
            {activeTab === 'notifications' && <div data-id="element-961">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-962">
                  Notification Settings
                </h2>
                <div className="space-y-6" data-id="element-963">
                  <div data-id="element-964">
                    <h3 className="text-md font-medium mb-4" data-id="element-965">
                      Email Notifications
                    </h3>
                    <div className="space-y-3" data-id="element-966">
                      <div className="flex items-center justify-between" data-id="element-967">
                        <div data-id="element-968">
                          <div className="font-medium" data-id="element-969">
                            New Member Registration
                          </div>
                          <div className="text-sm text-gray-500" data-id="element-970">
                            Get notified when a new member is registered
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-971">
                          <input type="checkbox" className="sr-only peer" checked data-id="element-972" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-973"></div>
                        </label>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-974">
                        <div data-id="element-975">
                          <div className="font-medium" data-id="element-976">New Duty Assignment</div>
                          <div className="text-sm text-gray-500" data-id="element-977">
                            Get notified when a new duty is assigned
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-978">
                          <input type="checkbox" className="sr-only peer" checked data-id="element-979" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-980"></div>
                        </label>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-981">
                        <div data-id="element-982">
                          <div className="font-medium" data-id="element-983">Lawajam Updates</div>
                          <div className="text-sm text-gray-500" data-id="element-984">
                            Get notified about lawajam payment updates
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-985">
                          <input type="checkbox" className="sr-only peer" checked data-id="element-986" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-987"></div>
                        </label>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-988">
                        <div data-id="element-989">
                          <div className="font-medium" data-id="element-990">System Updates</div>
                          <div className="text-sm text-gray-500" data-id="element-991">
                            Get notified about system updates and maintenance
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-992">
                          <input type="checkbox" className="sr-only peer" data-id="element-993" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-994"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-995">
                    <h3 className="text-md font-medium mb-4" data-id="element-996">
                      SMS Notifications
                    </h3>
                    <div className="space-y-3" data-id="element-997">
                      <div className="flex items-center justify-between" data-id="element-998">
                        <div data-id="element-999">
                          <div className="font-medium" data-id="element-1000">Emergency Alerts</div>
                          <div className="text-sm text-gray-500" data-id="element-1001">
                            Get SMS for emergency situations
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-1002">
                          <input type="checkbox" className="sr-only peer" checked data-id="element-1003" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-1004"></div>
                        </label>
                      </div>
                      <div className="flex items-center justify-between" data-id="element-1005">
                        <div data-id="element-1006">
                          <div className="font-medium" data-id="element-1007">Duty Reminders</div>
                          <div className="text-sm text-gray-500" data-id="element-1008">
                            Get SMS reminders for upcoming duties
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-1009">
                          <input type="checkbox" className="sr-only peer" data-id="element-1010" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-1011"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-1012">
                    <h3 className="text-md font-medium mb-4" data-id="element-1013">
                      In-App Notifications
                    </h3>
                    <div className="space-y-3" data-id="element-1014">
                      <div className="flex items-center justify-between" data-id="element-1015">
                        <div data-id="element-1016">
                          <div className="font-medium" data-id="element-1017">All Activity</div>
                          <div className="text-sm text-gray-500" data-id="element-1018">
                            Get notified for all system activities
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-1019">
                          <input type="checkbox" className="sr-only peer" checked data-id="element-1020" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-1021"></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end" data-id="element-1022">
                    <button className="bg-blue-800 text-white px-4 py-2 rounded-md" data-id="element-1023">
                      Save Notification Settings
                    </button>
                  </div>
                </div>
              </div>}
            {/* System Settings Tab */}
            {activeTab === 'system' && <div data-id="element-1024">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1025">
                  System Settings
                </h2>
                <div className="space-y-6" data-id="element-1026">
                  <div data-id="element-1027">
                    <h3 className="text-md font-medium mb-4" data-id="element-1028">
                      General Settings
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1029">
                      <div data-id="element-1030">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1031">
                          Organization Name
                        </label>
                        <input type="text" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue="Burhani Guards Dahod" data-id="element-1032" />
                      </div>
                      <div data-id="element-1033">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1034">
                          Contact Email
                        </label>
                        <input type="email" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" defaultValue="contact@burhaniguards.org" data-id="element-1035" />
                      </div>
                      <div data-id="element-1036">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1037">
                          Timezone
                        </label>
                        <select className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1038">
                          <option data-id="element-1039">Asia/Kolkata (GMT +5:30)</option>
                          <option data-id="element-1040">UTC (GMT +0:00)</option>
                          <option data-id="element-1041">America/New_York (GMT -4:00)</option>
                          <option data-id="element-1042">Europe/London (GMT +1:00)</option>
                        </select>
                      </div>
                      <div data-id="element-1043">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1044">
                          Date Format
                        </label>
                        <select className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1045">
                          <option data-id="element-1046">DD/MM/YYYY</option>
                          <option data-id="element-1047">MM/DD/YYYY</option>
                          <option data-id="element-1048">YYYY-MM-DD</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-1049">
                    <h3 className="text-md font-medium mb-4" data-id="element-1050">Backup & Data</h3>
                    <div className="space-y-4" data-id="element-1051">
                      <div className="flex items-center justify-between" data-id="element-1052">
                        <div data-id="element-1053">
                          <div className="font-medium" data-id="element-1054">Automatic Backups</div>
                          <div className="text-sm text-gray-500" data-id="element-1055">
                            System will automatically backup data daily
                          </div>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer" data-id="element-1056">
                          <input type="checkbox" className="sr-only peer" checked data-id="element-1057" />
                          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-800" data-id="element-1058"></div>
                        </label>
                      </div>
                      <div data-id="element-1059">
                        <button className="bg-blue-800 text-white px-4 py-2 rounded-md mr-3" data-id="element-1060">
                          Backup Now
                        </button>
                        <button className="border border-blue-800 text-blue-800 px-4 py-2 rounded-md" data-id="element-1061">
                          Restore Data
                        </button>
                      </div>
                      <div className="text-sm text-gray-500" data-id="element-1062">
                        Last backup: August 15, 2023 at 02:30 AM
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-1063">
                    <h3 className="text-md font-medium mb-4" data-id="element-1064">
                      System Information
                    </h3>
                    <div className="bg-gray-50 rounded-md p-4 space-y-2 text-sm" data-id="element-1065">
                      <div className="flex justify-between" data-id="element-1066">
                        <div className="text-gray-500" data-id="element-1067">Version</div>
                        <div data-id="element-1068">1.2.0</div>
                      </div>
                      <div className="flex justify-between" data-id="element-1069">
                        <div className="text-gray-500" data-id="element-1070">Last Updated</div>
                        <div data-id="element-1071">August 10, 2023</div>
                      </div>
                      <div className="flex justify-between" data-id="element-1072">
                        <div className="text-gray-500" data-id="element-1073">Database Size</div>
                        <div data-id="element-1074">245 MB</div>
                      </div>
                      <div className="flex justify-between" data-id="element-1075">
                        <div className="text-gray-500" data-id="element-1076">Total Members</div>
                        <div data-id="element-1077">140</div>
                      </div>
                      <div className="flex justify-between" data-id="element-1078">
                        <div className="text-gray-500" data-id="element-1079">Total Duties</div>
                        <div data-id="element-1080">583</div>
                      </div>
                      <div className="flex justify-between" data-id="element-1081">
                        <div className="text-gray-500" data-id="element-1082">
                          Total Lawajam Entries
                        </div>
                        <div data-id="element-1083">972</div>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-1084">
                    <h3 className="text-md font-medium mb-4 text-red-600" data-id="element-1085">
                      Danger Zone
                    </h3>
                    <div className="bg-red-50 border border-red-200 rounded-md p-4" data-id="element-1086">
                      <div className="flex items-center justify-between" data-id="element-1087">
                        <div data-id="element-1088">
                          <div className="font-medium text-red-800" data-id="element-1089">
                            Reset System Data
                          </div>
                          <div className="text-sm text-red-600" data-id="element-1090">
                            This action will erase all data and cannot be undone
                          </div>
                        </div>
                        <button className="bg-white border border-red-600 text-red-600 px-4 py-2 rounded-md hover:bg-red-600 hover:text-white transition-colors" data-id="element-1091">
                          Reset System
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-end" data-id="element-1092">
                    <button className="bg-blue-800 text-white px-4 py-2 rounded-md" data-id="element-1093">
                      Save System Settings
                    </button>
                  </div>
                </div>
              </div>}
            {/* Help & Support Tab */}
            {activeTab === 'help' && <div data-id="element-1094">
                <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1095">
                  Help & Support
                </h2>
                <div className="space-y-6" data-id="element-1096">
                  <div data-id="element-1097">
                    <h3 className="text-md font-medium mb-4" data-id="element-1098">Documentation</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1099">
                      <a href="#" className="border rounded-md p-4 hover:bg-gray-50" data-id="element-1100">
                        <div className="font-medium" data-id="element-1101">User Guide</div>
                        <div className="text-sm text-gray-500 mt-1" data-id="element-1102">
                          Complete guide on how to use the system
                        </div>
                      </a>
                      <a href="#" className="border rounded-md p-4 hover:bg-gray-50" data-id="element-1103">
                        <div className="font-medium" data-id="element-1104">Admin Manual</div>
                        <div className="text-sm text-gray-500 mt-1" data-id="element-1105">
                          Detailed guide for administrators
                        </div>
                      </a>
                      <a href="#" className="border rounded-md p-4 hover:bg-gray-50" data-id="element-1106">
                        <div className="font-medium" data-id="element-1107">FAQs</div>
                        <div className="text-sm text-gray-500 mt-1" data-id="element-1108">
                          Frequently asked questions
                        </div>
                      </a>
                      <a href="#" className="border rounded-md p-4 hover:bg-gray-50" data-id="element-1109">
                        <div className="font-medium" data-id="element-1110">Video Tutorials</div>
                        <div className="text-sm text-gray-500 mt-1" data-id="element-1111">
                          Step-by-step video guides
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-1112">
                    <h3 className="text-md font-medium mb-4" data-id="element-1113">
                      Contact Support
                    </h3>
                    <div className="bg-blue-50 rounded-md p-6" data-id="element-1114">
                      <div className="text-center mb-4" data-id="element-1115">
                        <HelpCircleIcon size={40} className="mx-auto text-blue-800 mb-2" data-id="element-1116" />
                        <h4 className="text-lg font-medium" data-id="element-1117">Need Help?</h4>
                        <p className="text-gray-500" data-id="element-1118">
                          Our support team is here to assist you
                        </p>
                      </div>
                      <div className="space-y-4" data-id="element-1119">
                        <div data-id="element-1120">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1121">
                            Subject
                          </label>
                          <input type="text" className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter subject" data-id="element-1122" />
                        </div>
                        <div data-id="element-1123">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1124">
                            Message
                          </label>
                          <textarea className="px-3 py-2 border rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500" rows={4} placeholder="Describe your issue in detail" data-id="element-1125"></textarea>
                        </div>
                        <button className="w-full bg-blue-800 text-white py-2 rounded-md" data-id="element-1126">
                          Submit Ticket
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="border-t pt-6" data-id="element-1127">
                    <h3 className="text-md font-medium mb-4" data-id="element-1128">
                      Contact Information
                    </h3>
                    <div className="space-y-3" data-id="element-1129">
                      <div className="flex items-start" data-id="element-1130">
                        <MailIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-1131" />
                        <div data-id="element-1132">
                          <div className="text-sm font-medium text-gray-500" data-id="element-1133">
                            Email
                          </div>
                          <div data-id="element-1134">support@burhaniguards.org</div>
                        </div>
                      </div>
                      <div className="flex items-start" data-id="element-1135">
                        <PhoneIcon size={18} className="mr-3 text-gray-500 mt-0.5" data-id="element-1136" />
                        <div data-id="element-1137">
                          <div className="text-sm font-medium text-gray-500" data-id="element-1138">
                            Phone
                          </div>
                          <div data-id="element-1139">+91 98765 43210</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
      {/* Logout Button */}
      <div className="flex justify-end" data-id="element-1140">
        <button className="flex items-center text-red-600 hover:text-red-800" data-id="element-1141">
          <LogOutIcon size={18} className="mr-1" data-id="element-1142" />
          <span data-id="element-1143">Logout</span>
        </button>
      </div>
    </div>;
};
export default SettingsScreen;